"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.number.constructor.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _trade = require("@/model/ucenter/trade");

var _message = require("@/components/dialog/message.js");

var _index = require("@/model/exchange/index");

var _settings = require("@/model/settings");

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _index2 = require("@/utils/index.js");

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _i18n = require("@/assets/js/i18n");

var _order = require("@/model/contractExchange/order.js");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  data: function data() {
    return {
      pageInfo: {
        pageCount: 0,
        pageTotal: 0,
        pageSize: 4,
        pageCurrent: 1
      },
      cardLoading: true,
      itemList: [],
      bail_number: "",
      position_order_id: "",
      dialogVisible: false,
      appendMoneydialog: false,
      setProfitPricedialog: false,
      contractList: [],
      beforeBailNumber: "",
      afterBailNumber: "--",
      inputProfitPrice: "",
      inputLossPrice: "",
      beforeLiquidationPrice: "",
      afterLiquidationPrice: "--",
      symbolList: {},
      apiAssetsInfo: {},
      rowData: {},
      contractProfitMap: {},
      assetsInfo: {
        type: Object,
        default: function _default() {
          return {
            remain: {
              all_u_valuation: {
                usdt: "--"
              },
              list: []
            }
          };
        }
      },
      sideMap: {
        1: "买",
        2: "卖"
      }
    };
  },
  components: {
    InputNumber: _InputNumber.default,
    NoData: _NoData.default
  },
  created: function created() {
    this.getItemList();
    this.getTradePairList();
    this.getAssets();
    this.getPositionList();
    this.startTimer();
  },
  methods: {
    translateTitle: _i18n.translateTitle,
    parseTime: _index2.parseTime,
    onClearAll: function onClearAll() {
      this.inputProfitPrice = "";
    },
    onClearAllV2: function onClearAllV2() {
      this.inputLossPrice = "";
    },
    onPageChange: function onPageChange() {
      this.getPositionList();
    },
    getItemList: function getItemList() {
      var settingList = JSON.parse(localStorage.getItem("settingList"));
      this.itemList = settingList[13];
    },
    startTimer: function startTimer() {
      var _this = this;

      this.getPositionList().then(function () {
        var timer = setTimeout(function () {
          _this.startTimer();
        }, 500);

        _this.$once("hook:beforeDestroy", function () {
          clearTimeout(timer);
        });
      });
    },
    getPositionList: function getPositionList() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var req, _yield$apiGetPosition, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                req = {
                  position_status: 1,
                  page: _this2.pageInfo.pageCurrent,
                  page_size: _this2.pageInfo.pageSize
                };
                _context.next = 3;
                return (0, _trade.apiGetPositionList)(req);

              case 3:
                _yield$apiGetPosition = _context.sent;
                status = _yield$apiGetPosition.status;
                data = _yield$apiGetPosition.data;
                _this2.cardLoading = false;

                if (status == 200) {
                  data.list.forEach(function (ele) {
                    for (var item in _this2.itemList) {
                      if (ele.open_item_id == _this2.itemList[item].item_id) {
                        ele.open_item_name = _this2.itemList[item].item_name.toUpperCase();
                      }

                      if (ele.settlement_item_id == _this2.itemList[item].item_id) {
                        ele.settlement_item_name = _this2.itemList[item].item_name.toUpperCase();
                      }
                    }
                  });
                  _this2.contractList = data.list;
                  _this2.pageInfo = data.pageInfo;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onClosePosition: function onClosePosition() {
      var _this3 = this;

      var params = {
        position_order_id: this.position_order_id
      };
      (0, _order.apiClosePosition)(params).then(function (res) {
        if (res.status == 200) {
          _this3.dialogVisible = false;
          (0, _message.showMessage)({
            message: "平仓成功",
            type: "success"
          }); // this.initData(this.checked);
        }
      });
    },
    onAppendMoney: function onAppendMoney() {
      var _this4 = this;

      var params = {
        position_order_id: this.position_order_id,
        bail_number: this.bail_number
      };
      (0, _order.apiAppendInterest)(params).then(function (res) {
        if (res.status == 200) {
          (0, _message.showMessage)({
            message: "追加成功",
            type: "success"
          });
          _this4.appendMoneydialog = false;

          _this4.initData(_this4.checked);
        }
      });
    },
    onProfitPriceEdit: function onProfitPriceEdit(row) {
      this.rowData = row;
      this.row_swap_symbol_id = row.symbol_id;
      this.setProfitPricedialog = true;
    },
    appendMoneydialogClose: function appendMoneydialogClose() {
      this.bail_number = "";
      this.appendMoneydialog = false;
    },
    onCloseAppend: function onCloseAppend() {
      this.bail_number = "";
      this.appendMoneydialog = false;
    },
    onOpenConfirm: function onOpenConfirm(position_order_id) {
      this.position_order_id = position_order_id;
      this.dialogVisible = true;
    },
    setProfitPricedialogClose: function setProfitPricedialogClose() {
      this.inputLossPrice = "";
      this.inputProfitPrice = "";
      this.setProfitPricedialog = false;
    },
    onOpenAppendMoney: function onOpenAppendMoney(item) {
      this.position_order_id = item.position_order_id;
      this.beforeBailNumber = item.bail_number;
      this.afterBailNumber = item.bail_number;
      this.beforeLiquidationPrice = item.liquidation_price;
      this.afterLiquidationPrice = item.liquidation_price;
      this.rowData = item; // this.symbol_id = item.symbol_id

      this.appendMoneydialog = true;
    },
    onClickAll: function onClickAll() {
      this.bail_number = this.assetsInfoShow;
    },
    onSetPositionProfitLoss: function onSetPositionProfitLoss() {
      var _this5 = this;

      var params = {
        position_order_id: this.rowData.position_order_id,
        market_price: this.rowMarketInfoShow.last,
        stop_profit_price: this.inputProfitPrice,
        stop_loss_price: this.inputLossPrice
      };
      (0, _order.apiSetPositionProfitLoss)(params).then(function (res) {
        if (res.status == 200) {
          (0, _message.showMessage)({
            message: "设置成功",
            type: "success"
          });

          _this5.setProfitPricedialogClose();

          _this5.initData(_this5.checked);
        }
      });
    },
    getAssets: function getAssets() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$apiGetAssets, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  type: "all"
                };
                _context2.next = 3;
                return (0, _index.apiGetAssets)(params);

              case 3:
                _yield$apiGetAssets = _context2.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status == 200) {
                  _this6.apiAssetsInfo = data;
                  _this6.contractProfitMap = data.contract;
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getTradePairList: function getTradePairList() {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(49);

              case 2:
                _yield$apiGetStaticTa = _context3.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this7.symbolList = data;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  computed: {
    // 现有U资产
    assetsInfoShow: function assetsInfoShow() {
      var _this8 = this;

      var tempObj = "0";

      if (JSON.stringify(this.assetsInfo) != "{}" && this.assetsInfo.remain.list.length > 0) {
        this.assetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this8.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else if (JSON.stringify(this.apiAssetsInfo) != "{}" && this.apiAssetsInfo.remain.list.length > 0) {
        this.apiAssetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this8.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = "--";
      }

      return tempObj;
    },
    afterLiquidationPriceShow: function afterLiquidationPriceShow() {
      // 强平价 = 开仓价 - (1 做多 | -1做空)) ×(保证金 × (1 − 强平⻛险率) - 平仓手续费-开仓手续费)/持仓数量
      var tempValue = "";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.bail_number != "") {
        tempValue = (this.rowData.open_price - tempSide * (this.afterBailNumberShow * (1 - this.symbolList[this.rowData.symbol_id].liquidation_risk_rate / 10000) - this.rowData.close_position_fee - this.rowData.open_position_fee) / this.rowData.open_interest).toFixed(2);
      } else {
        tempValue = this.afterLiquidationPrice;
      }

      return tempValue;
    },
    afterBailNumberShow: function afterBailNumberShow() {
      return (Number(this.afterBailNumber) + Number(this.bail_number)).toFixed(2);
    },
    // 平仓盈亏 = (inputProfitPrice-开仓价) × (1 做多 | -1做空)) × 持仓数量  - 平仓手续费
    expectedProfit: function expectedProfit() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputProfitPrice != "" && Number(this.inputProfitPrice) != 0) {
        tempValue = ((this.inputProfitPrice - this.rowData.open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee).toFixed(2);
      } // inputProfitPrice


      return tempValue;
    },
    expectedProfitPercent: function expectedProfitPercent() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputProfitPrice != "" && Number(this.inputProfitPrice) != 0) {
        tempValue = (((this.inputProfitPrice - this.rowData.open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee) / this.rowData.bail_number).toFixed(2);

        if (Number(tempValue) > 0) {
          tempValue = "+" + tempValue;
        }
      } // inputProfitPrice


      return tempValue;
    },
    // 平仓盈亏 = (inputLossPrice-开仓价) × (1 做多 | -1做空)) × 持仓数量  - 平仓手续费
    expectedLoss: function expectedLoss() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputLossPrice != "" && Number(this.inputLossPrice) != 0) {
        tempValue = ((this.inputLossPrice - this.rowData.open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee).toFixed(2);
      } // inputLossPrice


      return tempValue;
    },
    expectedLossPercent: function expectedLossPercent() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputLossPrice != "" && Number(this.inputLossPrice) != 0) {
        tempValue = (((this.inputLossPrice - this.rowData.open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee) / this.rowData.bail_number).toFixed(2);
      } // inputLossPrice


      return tempValue;
    }
  }
};
exports.default = _default2;